export default __webpack_public_path__ + "static/BrochureQRcode-0f0057e01db8c58a50d37dfcd10a1f5f.webp";